module.exports = __webpack_public_path__ + "img/detail-3.2069b5c1.png";